import { render, staticRenderFns } from "./MerchantApplyDialog.vue?vue&type=template&id=533622e2"
import script from "./MerchantApplyDialog.vue?vue&type=script&lang=js"
export * from "./MerchantApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./MerchantApplyDialog.vue?vue&type=style&index=0&id=533622e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports